import { storeToRefs } from 'pinia';
import type { Ref } from 'vue';
import { computed } from 'vue';
import BetConstructStream from '@/components/liveStream/betConstructStream/BetConstructStream.vue';
import type { UseLiveStreamEvent, UseLiveStreamProvider } from '@/composable/liveStream/useLiveStream';
import { LiveStreamProvider } from '@/interface/enum';
import { useCustomerStore } from '@/store/customerStore';

export function useBetConstructStream(event: Ref<UseLiveStreamEvent | null>): UseLiveStreamProvider {
    const { ipCountryCode } = storeToRefs(useCustomerStore());

    const isAvailable = computed(() => !!event.value?.stream?.betConstruct?.allowedCountries?.includes(ipCountryCode.value));

    const isPlayable = computed(() => isAvailable.value);

    const streamDisplay = computed(() => {
        if (!isPlayable.value || !event.value?.stream?.betConstruct) return null;

        return {
            provider: LiveStreamProvider.BetConstruct,
            component: BetConstructStream,
            key: event.value.stream.betConstruct.eventId.toString(),
            props: {
                betConstruct: event.value.stream.betConstruct,
            },
        };
    });

    return {
        isAvailable,
        isPlayable,
        streamDisplay,
    };
}
